// The issue's comments (FR-ISS-13, FR-PRJ-09). A link to the Spec tab's
// Issue panel (`#issue-panel`: the other tabs' Try again, Specter's lines
// reading the issue) or to one of the issue's comments
// (`#issue-comment-123`: Refreshed: 2 new comments, a refresh's line in the
// conversation, Go to issue with a comment's link from GitHub) opens the
// fold the comment is in, so the link lands on what it was for: the panel's
// Issue body and comments, or the issue's page's Show its 3 comments
// (FR-URL-14). A comment the issue no longer has leads to the panel.
// Without the bundle the browser's own jump still reaches the panel.

const PANEL = "issue-panel";
const COMMENT = /^issue-comment-\d+$/;

/** The panel's fold of the issue's body and comments. */
const PANEL_FOLD = `#${PANEL} details.issue-text-fold`;

export function openLinkedComment(): void {
  const id = location.hash.slice(1);
  if (id !== PANEL && !COMMENT.test(id)) return;
  const comment = id === PANEL ? null : document.getElementById(id);
  const panel = document.getElementById(PANEL);
  const target = comment ?? panel;
  if (!target) return;
  // Every fold around the comment, or the panel's own.
  const folds: HTMLDetailsElement[] = [];
  if (comment) {
    for (
      let at = comment.closest("details");
      at;
      at = at.parentElement?.closest("details") ?? null
    ) {
      folds.push(at);
    }
  } else {
    const fold = document.querySelector<HTMLDetailsElement>(PANEL_FOLD);
    if (fold) folds.push(fold);
  }
  let opened = false;
  for (const fold of folds) {
    if (fold.open) continue;
    fold.open = true;
    opened = true;
    // Shown where it lands at once, not eased in from a little lower
    // (`details[open]` in the stylesheet), so the jump below stays put.
    for (const shown of fold.querySelectorAll(":scope > :not(summary)")) {
      for (const easing of shown.getAnimations()) easing.finish();
    }
  }
  // The browser jumped before the fold opened: what it opened is brought
  // into view, in the sidebar and in the box that scrolls within it. A fold
  // open already was the browser's to jump into, and a reload's place is
  // left where the browser keeps it.
  if (opened) target.scrollIntoView({ block: "start" });
}

openLinkedComment();
addEventListener("hashchange", openLinkedComment);
